export const LocationWizardSteps = {
  BASIC_INFO: 'basic-info',
  HOURS: 'hours',
  CONTACT: 'contact'
} as const;

export type LocationWizardStep = typeof LocationWizardSteps[keyof typeof LocationWizardSteps];

export const LOCATION_WIZARD_STEP_ORDER: LocationWizardStep[] = [
  LocationWizardSteps.BASIC_INFO,
  LocationWizardSteps.HOURS,
  LocationWizardSteps.CONTACT
];

export const LOCATION_WIZARD_STEP_LABELS: Record<LocationWizardStep, string> = {
  [LocationWizardSteps.BASIC_INFO]: 'Basic Info',
  [LocationWizardSteps.HOURS]: 'Hours',
  [LocationWizardSteps.CONTACT]: 'Contact'
};

export const isLocationWizardStep = (value: string | undefined): value is LocationWizardStep =>
  Object.values(LocationWizardSteps).includes(value as LocationWizardStep);
